exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.fields[data-v-61db49d9] {\n   max-height: 70vh;\n   overflow-y: auto;\n}\n", ""]);

// exports
